import { FITNESS_AGE_FACTORS } from './fitnessAgeConstants';
import AnalyticsUtil from 'utils/AnalyticsUtil';

export const FITNESS_AGE_INVALID_TYPES = {
    USER_UNDER_AGE: 'USER_UNDER_AGE',
    USER_OVER_AGE: 'USER_OVER_AGE',
    USER_PREGNANT: 'USER_PREGNANT'
};

export const isBodyFatOrBMI = (key) => {
    return key === FITNESS_AGE_FACTORS.bmi.key || key === FITNESS_AGE_FACTORS.bodyFat.key;
};

export const roundFitnessAgeData = (fitnessAgeData) => {
    if (
        !fitnessAgeData ||
        Object.keys(fitnessAgeData).length === 0 ||
        !fitnessAgeData.achievableFitnessAge ||
        !fitnessAgeData.fitnessAge
    ) {
        return fitnessAgeData;
    }

    const roundedFitnessAgeData = window.structuredClone(fitnessAgeData);

    // round at 0.5 (instead of at integers), and it can be up or down

    // achievable fitness age is rounded down
    roundedFitnessAgeData.achievableFitnessAge = Math.floor(fitnessAgeData.achievableFitnessAge * 2) / 2;

    // if fitnessAge > achievableFitnessAge in real values → fitnessAge is rounded up
    if (fitnessAgeData.fitnessAge > fitnessAgeData.achievableFitnessAge) {
        roundedFitnessAgeData.fitnessAge = Math.ceil(fitnessAgeData.fitnessAge * 2) / 2;
    } else {
        // fitnessAge <= achievableFitnessAge in real values → fitnessAge is rounded down
        roundedFitnessAgeData.fitnessAge = Math.floor(fitnessAgeData.fitnessAge * 2) / 2;
    }

    if (!roundedFitnessAgeData.components || Object.keys(roundedFitnessAgeData.components).length === 0) {
        return roundedFitnessAgeData;
    }

    // from components only potentialAge is rounded, up
    Object.keys(roundedFitnessAgeData.components).forEach((componentKey) => {
        const componentObject = roundedFitnessAgeData.components[componentKey];

        if (componentObject.potentialAge) {
            const roundedPotentialAge = Math.ceil(componentObject.potentialAge * 2) / 2;
            roundedFitnessAgeData.components[componentKey].potentialAge = roundedPotentialAge;
        }

        //value is rounded only for Vigorous Minutes component
        if (componentKey == FITNESS_AGE_FACTORS.vigorousMinutesAvg.key) {
            const roundedVigorousMinutesValue = Math.round(componentObject.value);
            roundedFitnessAgeData.components[componentKey].value = roundedVigorousMinutesValue;
        }
    });

    return roundedFitnessAgeData;
};

export const hasStaleMetrics = (fitnessAgeData) => {
    if (!fitnessAgeData || !fitnessAgeData?.components || Object.keys(fitnessAgeData?.components).length === 0) {
        return false;
    }
    const isStaleArray = Object.keys(fitnessAgeData.components).map((componentKey) => {
        const componentObject = fitnessAgeData.components[componentKey];
        return componentObject?.stale === true;
    });
    return isStaleArray.some((item) => item === true);
};

export function pushFitnessAgeEventToAnalytics(action) {
    AnalyticsUtil.push({
        event: 'track_event',
        category: 'Fitness Age Events',
        action: action
    });
}
